
/**
 * Market-aware cart drawer redirection.
 * Redirects cart URLs to the current market's homepage
 * and opens the cart drawer.
 */
(() => {
  const marketRoot = (window.Shopify?.routes?.root || '/')
    .replace(/\/?$/, '/');

  const currentPath =
    window.location.pathname.replace(/\/+$/, '');

  const cartPath = `${marketRoot}cart`;
  const cartOpenPath = `${marketRoot}cart_open`;

  // Preserve existing theme-body initialization.
  document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('theme_body')
      ?.classList.add('show-theme-body');
  });

  // Redirect cart URLs without changing markets.
  if (currentPath === cartPath || currentPath === cartOpenPath) {
    sessionStorage.setItem('openCartDrawer', 'true');
    window.location.replace(marketRoot);
  }

  function openCartDrawerWhenReady() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      return;
    }

    // Fallback if the drawer function is unavailable.
    const drawer = document.getElementById('CartDrawerContainer');

    if (drawer) {
      drawer.classList.add('active');
      document.body.classList.add('cart-drawer-open');
    }
  }

  window.addEventListener('load', () => {
    const requestedByUrl =
      new URLSearchParams(window.location.search)
        .get('open_cart') === '1';

    const requestedByRedirect =
      sessionStorage.getItem('openCartDrawer') === 'true';

    if (requestedByUrl || requestedByRedirect) {
      sessionStorage.removeItem('openCartDrawer');
      setTimeout(openCartDrawerWhenReady, 500);
    }
  });
})();
